import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import API from '../../../config/axios.config';
import { API_ENDPOINTS } from '../../../shared/api-endpoints';

export const InfluencerVerifyOtpApi: any = createAsyncThunk('influencerVerifyOtpApi', async (input: any) => {
	try {
		const { headers } = input;
		const { data } = await API.post(API_ENDPOINTS.INFLUENCER_VERIFY_OTP, {}, { headers });
		return data;
	} catch (verifyOtpError: any) {
		return verifyOtpError?.response?.data;
	}
});

const InfluencerVerifyOtpSlice = createSlice({
	name: 'influencerVerifyOtpApi',
	initialState: {
		verifyOtpRes: [],
		verifyOtpLoad: false,
		verifyOtpError: ''
	},
	reducers: {
		reset: (state) => {
			state.verifyOtpRes = [];
			state.verifyOtpLoad = false;
			state.verifyOtpError = '';
		}
	},
	extraReducers: (builder) => {
		builder.addCase(InfluencerVerifyOtpApi.fulfilled, (state, action: any) => {
			state.verifyOtpLoad = false;
			state.verifyOtpRes = action.payload;
			state.verifyOtpError = '';
		});

		builder.addCase(InfluencerVerifyOtpApi.pending, (state) => {
			state.verifyOtpLoad = true;
		});

		builder.addCase(InfluencerVerifyOtpApi.rejected, (state, action: any) => {
			state.verifyOtpLoad = false;
			state.verifyOtpRes = [];
			state.verifyOtpError = action.payload;
		});
	}
});

export const { reset: resetInfluencerVerifyOtp } = InfluencerVerifyOtpSlice.actions;
export const InfluencerVerifyOtpApiSlice = InfluencerVerifyOtpSlice.reducer;